import { InvestmentPriceMovementProps } from 'modules/clients/types/transaction-summary';
import styles from '../transaction-summary.module.scss';
import TransactionSummaryHeadingRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryHeadingRow';
import TransactionSummaryRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryRow';

const InvestmentPriceMovement = ({ priceMovement, totalReturn }: InvestmentPriceMovementProps) => {
  return (
    <div className={styles.container}>
      <TransactionSummaryHeadingRow
        testid='transactionSummaryInvestmentPriceMovementReturn'
        data-testid='transactionSummaryInvestmentPriceMovementReturnHeadingRow'
        heading='Investment price movement and return'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryInvestmentPriceMovementRow'
        heading='Investment price movement'
        amount={priceMovement}
        testid='transactionSummaryInvestmentPriceMovement'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryInvestmentReturnRow'
        heading='Total investment return'
        amount={totalReturn}
        testid='transactionSummaryInvestmentReturn'
      />
    </div>
  );
};

export default InvestmentPriceMovement;
